import { AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { OperatorService } from 'src/app/modules/administration/services/operator.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { IMachineStatus } from 'src/app/modules/widget/interfaces/machine-status';
import { MACHINE_CODES } from '../../../../../../../../projects/common/src/app/enumerables/machine-codes';
import { IMachineContext } from '../../../../../../../../projects/common/src/app/interfaces/machine-context';
import { ParameterHandlerService } from '../../../../../../../../projects/common/src/app/services/parameter-handler.service';

@Component({
  selector: 'app-summary-team',
  templateUrl: './summary-team.component.html',
  styleUrls: ['./summary-team.component.scss'],
})
export class SummaryTeamComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() public summary: IMachineStatus;

  public machine: IMachineStatus;
  public loopsLabel: string;
  public lastLoopLabel: string;
  public isJumbo: boolean;
  public messageTime: string;
  public tooltipDescription: string;
  public translateSummary: { lastProduction: string; productionMtsJumbo?: string; productionByMachine: string; timeLastProduction: string };

  constructor(
    private languageService: LanguageService,
    private parameterService: ParameterHandlerService,
    public operatorService: OperatorService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.tooltipDescription = `${languageService.message('outside-park')}\n`;
  }

  ngOnInit() {
    this.translateSummary = {
      lastProduction: '',
      productionByMachine: '',
      timeLastProduction: '',
      productionMtsJumbo: '',
    };
    const machineContext = this.parameterService.parameters.item('machine-context').value as IMachineContext;
    this.getTranslateSummary(machineContext.name);
    this.isJumbo = machineContext.code === MACHINE_CODES.jumbo;

    const customEvent = {
      modal_widget: 'asarco_state',
      tab_modal: 'asarco_state_summary-tean',
    };
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.summary && changes.summary.currentValue) {
      this.machine = changes.summary.currentValue;

      const machineContext = this.parameterService.parameters.item('machine-context').value as IMachineContext;
      this.getTranslateSummary(machineContext.name);
    }
  }

  ngAfterViewInit(): void {
    if (this.summary) {
      this.machine.operatorName = this.summary.operatorName || '-';
      this.cdr.detectChanges();
    }
  }

  public getTranslateSummary(machineContext: string): void {
    const messageSectionTime = `${this.languageService.message('time_since_last')}`;
    switch (machineContext) {
      case 'lhd':
        this.translateSummary = {
          lastProduction: this.languageService.message('last_loop'),
          productionByMachine:
            this.machine.countMeasure === 0 || this.machine.countMeasure > 1
              ? this.languageService.message('shelves_team')
              : this.languageService.message('shelve_team'),
          timeLastProduction: `${messageSectionTime} ${this.languageService.message('loop').toLowerCase()}`,
        };
        break;
      case 'jumbo':
        this.translateSummary = {
          lastProduction: this.languageService.message('last_drilling'),
          productionByMachine:
            this.machine.countMeasure === 0 || this.machine.countMeasure > 1
              ? this.languageService.message('drillings_team')
              : this.languageService.message('drilling_team'),
          timeLastProduction: `${messageSectionTime} ${this.languageService.message('drilling').toLowerCase()}`,
          productionMtsJumbo: this.languageService.message('perforated_mts'),
        };
        break;
      case 'truck':
        this.translateSummary = {
          lastProduction: this.languageService.message('last-loop-short'),
          productionByMachine:
            this.machine.countMeasure === 0 || this.machine.countMeasure > 1
              ? this.languageService.message('loops_team')
              : this.languageService.message('loop_team'),
          timeLastProduction: `${messageSectionTime} ${this.languageService.message('transfers').toLowerCase()}`,
        };
        break;
      default:
        break;
    }
  }
}
